export enum AppointmentCancelStatus {
    LISTED = "LISTED",
    ON_CONFIRM = 'ON_CONFIRM',
    ON_REQUEST= 'ON_REQUEST',
    CANCELLED='CANCELLED', 
    DENIED='DENIED'    
}